export function reduceAction(state, name, value) {
    return state[name] === value ? state : { ...state, [name]: value };
}
